import React, { useState as uState } from 'react'

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'

import { useNavigate as uNavigate } from 'react-router-dom'

import Med from '../../assets/images/medicines.png'
import './forgetPass.css'

export default function forgetPassword() {
    const navigate = uNavigate()
    const [user, setUser] = uState({
        email:'',
        oldPassword: "",
        newPassword:"",
        confirmPassword: "",        
    })
    console.log(user.confirmPassword)

    const handleChange = (event) => {
        setUser({
            ...user,
            [event.target.name]: event.target.value
        })
    }

    const handleForget = async (e) => {

        if (user.newPassword === user.confirmPassword) {
            e.preventDefault()
            const response = await fetch('http://localhost:8000/users/forget', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email:user.email,
                    oldPassword: user.oldPassword,
                    confirmPassword: user.confirmPassword
                })
            })
            const json = await response.json()
            if (!json.success) {
                alert('enter valid inputs')
            }
            else {
                navigate('/login')
            }
        } else {
            console.log('enter credentials first')
        }
    }
    const handleShowPass = () => {
        const Text = document.getElementById('form3Example3')
        const Text1 = document.getElementById('form3Example4')
        const Text2 = document.getElementById('form3Example5')
        const InnerHtml = document.getElementById('showPass')
        if (Text.type === 'password' && Text1.type === 'password' && Text2.type === 'password') {
            Text.type = 'text'
            Text1.type = 'text'
            Text2.type = 'text'
            InnerHtml.innerHTML = 'Hide Password'
        }
        else {
            Text.type = 'password'
            Text1.type = 'password'
            Text2.type = 'password'

            InnerHtml.innerHTML = 'Show Password'
        }


    }
    return (

        <>
            <Navbar />
            <section className="vh-100 ">
                <div className="container-fluid h-custom">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-md-9 col-lg-6 col-xl-5 medicines">
                            <img src={Med} className="img-fluid" alt="Sampleimage" />
                        </div>
                        <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
                            <form onSubmit={handleForget}>
                                <div className="form-outline mb-4">
                                    <input required type="email" id="form3Example6" className="form-control form-control-lg"
                                        name="email" value={user.email} onChange={handleChange} placeholder="Enter Email" />
                                    <label className="form-label" htmlFor="form3Example6">Email</label>
                                </div>
                                <div className="form-outline mb-4">
                                    <input required type="password" id="form3Example3" className="form-control form-control-lg"
                                        name="oldPassword" value={user.oldPassword} onChange={handleChange} placeholder="Enter Old Password" />
                                    <label className="form-label" htmlFor="form3Example3">Old Password</label>
                                </div>


                                <div className="form-outline mb-3">
                                    <input required type="password" id="form3Example4" className="form-control form-control-lg"
                                        name="newPassword" value={user.newPassword} onChange={handleChange} placeholder="Enter New Password" />
                                    <label className="form-label" htmlFor="form3Example4">New Password</label>
                                </div>
                                <div className="form-outline mb-3">
                                    <input required type="password" id="form3Example5" className="form-control form-control-lg"
                                        name="confirmPassword" value={user.confirmPassword} onChange={handleChange} placeholder="Confirm Your Password" />
                                    <label className="form-label" htmlFor="form3Example5">Confirm Password</label>
                                </div>
                                <div className="form-check mb-0">
                                    <input onClick={handleShowPass} className="form-check-input me-2" type="checkbox" value="" id="form2Example3" />
                                    <label id='showPass' className="form-check-label" htmlFor="form2Example3">
                                        Show Password
                                    </label>
                                </div>
                                <div className="text-center text-lg-start  mt-1 pt-2">
                                    <button type="submit" className="btn btncolor btn-lg" id='Loginbtn' style={{ paddingLeft: '2.5rem', paddingRight: '2.5rem' }}>Update</button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>

            </section>
            <Footer />
        </>
    )
}
